import { MailerOptions, TemplateAdapter } from '@nestjs-modules/mailer'
import { HandlebarsAdapter } from '@nestjs-modules/mailer/adapters/handlebars.adapter'
import mjml from 'mjml'

export class MjmlAdapter implements TemplateAdapter {
	private engine: HandlebarsAdapter

	constructor() {
		this.engine = new HandlebarsAdapter({}, { inlineCssEnabled: false })
	}

	public compile(mail: any, callback: any, mailerOptions: MailerOptions): void {
		this.engine.compile(
			mail,
			async () => {
				mail.data.html = (await mjml(mail.data.html)).html
				callback()
			},
			mailerOptions,
		)
	}
}
